define(
  [
    "i18n/i18n",
    "model/properties",
    "api/v2/search",
    "api/v2/api",
    "jquery",
    "underscore",
    "utils/array",
    "utils/url",
    "utils/trace",
    "360/builtin-result-properties-enrichment-handler-factory-v1",
    "360/mindbreeze-360-model",
    "service/channel",
    "!!raw-loader!./template/show-more-result.html"
  ],
  function(
    i18n,
    PropertiesModel,
    Search,
    api,
    $,
    _,
    ArrayUtils,
    urlUtil,
    Trace,
    BuiltinResultPropertiesEnrichmentHandlerFactoryV1,
    MindbreezeModels,
    Channel,
    SHOW_MORE_RESULT_TEMPLATE
  ) {
    function Degree360(options) {
      this.config = _.extend({}, options.config || {});
      this.application = options.application || {};
    }

    
    _.extend(Degree360.prototype, {
      initialize: function() {
        var that = this;

        var builtinResultEnrichment = new BuiltinResultPropertiesEnrichmentHandlerFactoryV1(this);

        this.application.registerResultPropertiesEnrichmentHandlerFactoryV1(builtinResultEnrichment);

        if (this.config.i18n) {
          i18n.loadExtension(this.config.i18n);
        }

        function collectDefinitionKeys(itemClasses) {
          let keys = [];
          for (let itemClass in itemClasses) {
            if (itemClasses[itemClass].hasOwnProperty("definition")) {
              keys = keys.concat(Object.keys(itemClasses[itemClass].definition));
            }
          }

          function onlyUnique(value, index, array) {
            return array.indexOf(value) === index;
          }

          return keys.filter(onlyUnique);
        }

        var allPropDefinitions = collectDefinitionKeys(this.config.itemClasses);
        var extraProperties = allPropDefinitions.reduce(function(curreObj, property) {
          curreObj[property] = { format: "VALUE" };

          return curreObj;
        }, {});

        const collectionForObjectType = new Search.ResultCollection(extraProperties);
        collectionForObjectType.objectTypeCollection = true;

        var searchModel = this.application.models.search;

        if (searchModel) {
          searchModel.addResultCollection(collectionForObjectType, {
            silent: true,
            global: true
          });
          searchModel.once("dispose", function() {
            collectionForObjectType.dispose();
          });
        }

        function getActionOptionsFromAnnotation(options, app) {
          let propLabel, annotatedText, queryExpr;

          var href = options.targetInfo && options.targetInfo.href;

          if (href) {
            propLabel = urlUtil.getQueryParam(href, "prop-label");
            annotatedText = urlUtil.getQueryParam(href, "annotated-text") || urlUtil.getQueryParam(href, "prop-annotated-text");
            const queryExprText = urlUtil.getQueryParam(href, "queryjsonv2");
            if (queryExprText) {
              try {
                queryExpr = JSON.parse(queryExprText);
              } catch (e) {
                console.warn("Failed to parse queryExpr", e);
                return Promise.reject(e);
              }
            } else {
              const queryExprLabel = urlUtil.getQueryParam(href, "query-expr-label");
              const queryExprValue = urlUtil.getQueryParam(href, "query-expr-value");
              if (queryExprLabel && queryExprValue) {
                queryExpr =  {"label": queryExprLabel, "unparsed": queryExprValue };
              }
            }
          } else if (options.targetInfo && options.targetInfo.getAttributeNames()) {
            propLabel = options.targetInfo.getAttribute("data-prop-label");
            annotatedText = options.targetInfo.getAttribute("data-annotated-text");
          }
          if (queryExpr) {
            // TODO use queryExpr JSON directly
            return that.queryForMainItem(queryExpr, app).then(mainItemInfo => {
              return Object.assign(options, mainItemInfo);
            });
          }
          else if (propLabel && annotatedText) {

            var mindbreeze360Model = app.getExtensionManager().get360Module().getMindbreeze360Model();
            if (!mindbreeze360Model) {
              return;
            }
            var entityFormat = mindbreeze360Model.getEntityFormatForLabel(propLabel);
            
            if (!entityFormat) {
              console.log("Not entityFormat was found for label: " + propLabel);
              return;
            }
            
            var itemClasses = mindbreeze360Model.getAllUniqueItemClassConfigsForEntityFormat(entityFormat);
            if (!itemClasses.length) {
              console.log("Not item class was found for entity format: " + entityFormat.name);
              return;
            }
            
            var propDef = itemClasses[0].getPropertyDefinitionsForEntityFormat(entityFormat, { unique: true });
            
            if (!propDef) {
              console.log("Not property deginition was found for item class: " + itemClasses[0].name);
              return;
            }
            
            var linkConstraint = new MindbreezeModels.LinkConstraint(propDef.name, [annotatedText]);
            
            options.itemClassName = itemClasses[0].name;
            options.itemClassConfig = itemClasses[0];
            options.constraint = linkConstraint.toQueryExpr();
            
            return Promise.resolve(options);
          }
          return Promise.reject();
        }

        var executeApplication = function(app) {
          var model = app.models.search.output.submodel("resultset.results");
          app.listenTo(
            model,
            "change",
            app.getExtensionManager().get360Module().analyzeResultsForExactMatchAndMainEntry.bind(that)
          );

          app.views.on("*:annotation:mouseover", function(options) {            
            getActionOptionsFromAnnotation(options, app).then(options => {
              if (!options) return;
              
              options.action = "show360";
              options.mode = "preview";
              options.targetInfo.offset.top = options.targetInfo.offset.top + 10;
              options.frameEl = options.targetInfo.frameEl;
              
              var href = options.targetInfo && options.targetInfo.href;
              
              if (href) {
                var searchParams = new URL(href).searchParams;
                var entries = searchParams.entries();
                
                for (var i = 0; i < entries.length; i++) {
                  var pair = entries[i];
                  var key = pair[0];
                  var value = pair[1];
                  
                  if (key !== "mes:CharOffset") {
                    options[key] = value;
                  }
                }
              }

              let previewApplication =
                  app.models.stack && app.models.stack.lastChild() && app.models.stack.lastChild().get("application");

              if (!previewApplication) {
                previewApplication = app;
              }
              
              const pdfPreviewEl = $(previewApplication.rootEls).find("iframe")[0];
              var event = (options.targetInfo && options.targetInfo.event) || {};
              // application calls to open stack/preview --> it will result child application
              
              var delay = 500;
              if (app.options.initAction && app.options.initAction.settings && app.options.initAction.settings['preview.mouseOverActionPreviewDelayInMS'] != undefined) {
                delay = app.options.initAction.settings['preview.mouseOverActionPreviewDelayInMS'];
              }

              that.showAnnotationPreviewTimeout = setTimeout(function() {
                app.handleAction(
                  options,
                  options.action,
                  pdfPreviewEl,
                  null,
                  previewApplication,
                  pdfPreviewEl,
                  options.traceContext,
                  event
                );
              }, delay);
            });
          });

          app.views.on("preview:annotation:mouseleave", function(options) {
            clearTimeout(that.showAnnotationPreviewTimeout);
            if (app.activePreview && app.activePreview.outsideHandler) {
              setTimeout(function() {
                app.activePreview &&
                  app.activePreview.outsideHandler({
                    annotationId: options.annotationId
                  });
              }, 100); // Because I want to trigger insideHandler firstly
            }
          });

          app.views.on("preview:annotation:click", function(options) {
            clearTimeout(that.showAnnotationPreviewTimeout);
            options.mode = "stack";
            options.mode = options.mode || "preview";
            getActionOptionsFromAnnotation(options, options.application).then(
              actionOptions => {
                if (!actionOptions) {
                  return;
                }
                that.show360(actionOptions);
              });
          });

          app.views.on("show360", function(options) {
            options.mode = "preview";

            var delay = 0;
            if (app.options.initAction && app.options.initAction.settings && app.options.initAction.settings['result.mouseOverActionPreviewDelayInMS'] != undefined) {
              delay = app.options.initAction.settings['result.mouseOverActionPreviewDelayInMS'];
            }
            setTimeout(function() {
              // TODO move query to show360
              that.show360(options);
            }, delay);
          });

          app.listenTo(app, "remove360", function() {
            app.stopListening(
              model,
              "change",
              app.getExtensionManager() &&
                app.getExtensionManager().get360Module() &&
                app.getExtensionManager().get360Module().analyzeResultsForExactMatchAndMainEntry
            );
            app.views.off("*:annotation:mouseover preview:annotation:mouseleave preview:annotation:click show360");
            app.unregisterResultPropertiesEnrichmentHandlerFactoryV1(builtinResultEnrichment);
            app.getExtensionManager().remove360Module();
            app.off("remove360");
          });
        };

        this.application.execute(executeApplication);
      },

      queryForMainItem: function(queryExpr, app) {
        let that = this;
        return new Promise((resolve, reject) => {
          var modelOptions = {
            clientExtensions: app.getClientExtensions(),
            enableImmediateDisplayOfFederatedResults: app.options.enableImmediateDisplayOfFederatedResults,
          }

          var model = api.search.createModel(app.models.channels, modelOptions);
          // that._prepare360ViewMainModel(model);
          var linkSourcePropertyNames = that._getRelationshipProperties();
          var computedProperties = that._getComputedProperties(linkSourcePropertyNames);
          
          if (!_.isEmpty(computedProperties)) {
            var existingComputedProperties = model.input.get("computed_properties") || [];
            var effectiveProps = existingComputedProperties.concat(computedProperties);
            model.input.set("computed_properties", effectiveProps, {
              silent: true
            });
          }

          function collectDefinitionKeys(itemClasses) {
            let keys = [];
            for (let itemClass in itemClasses) {
              if (itemClasses[itemClass].hasOwnProperty("definition")) {
                keys = keys.concat(Object.keys(itemClasses[itemClass].definition));
              }
            }
            
            function onlyUnique(value, index, array) {
              return array.indexOf(value) === index;
            }
            return keys.filter(onlyUnique);
          }

          var allPropDefinitions = collectDefinitionKeys(this.config.itemClasses);
          allPropDefinitions.push("mes:key");
          var requestedProperties = allPropDefinitions.reduce(function(curreObj, property) {
            curreObj[property] = { formats: ["VALUE"] };
            return curreObj;
          }, {});
          
          
          function analyzeResultsForItemClassConfigAndReturnOptions(resultList, queryExpr, allPropDefinitions) {
            const m360Model = that.getMindbreeze360Model();
            var resultPropertiesModel = new PropertiesModel(resultList[0].properties);
            const itemClassConfig = m360Model.findItemClassConfigForResult(resultPropertiesModel);
            if (!itemClassConfig) {
              return;
            }
            let options = {};
            options.itemClassName = itemClassConfig.name;
            options.itemClassConfig = itemClassConfig;
            options.constraint = queryExpr;
            options.properties = {};
            for (var propName of allPropDefinitions) {
              let propValue = resultPropertiesModel.get(propName);
              if (propValue) {
                options.properties[propName] = propValue;
              }
            }

            return options;                
          }
          // Once listen to computed
          model.once("computed", function() {
            // take the first element.
            let resultList = model.output.get("resultset.results");
            if (!resultList || resultList.length == 0) {
              reject();
            }
            resolve(analyzeResultsForItemClassConfigAndReturnOptions(resultList, queryExpr, allPropDefinitions));
          });

          model.input.set({"count": 1, "constraint": queryExpr, "properties": requestedProperties});
          
        });
      },

    
    analyzeResultsForExactMatchAndMainEntry: function(results) {
        try {
          this._checkIsMainEntryForViewAndProvideVars(results);
        } catch (e) {
          console.warn("Failed to handle entry", e);
        }
      },

      show360: function(options) {
        var that = this;
        if (options.event && options.event.type === "mouseover" && options.mode !== "preview") {
          this.application.views.trigger("show360", options);
          return;
        }

        this._closePreview();
        
        var calcOffsetPosition = function(rect, target, offset) {
          const boundingParentRect = rect.getBoundingClientRect();
          offset.top = target.offset.top + boundingParentRect.top;
          offset.left = target.offset.left + boundingParentRect.left;
          offset.bottom = offset.top + target.dimensions.height;
          offset.right = offset.left + target.dimensions.width;
        };

        if (options.mode === "preview") {
          const offset = {
            top: 0,
            left: 0
          };
          if (options.targetInfo) {
            if (options.frameEl) {
              calcOffsetPosition(options.frameEl, options.targetInfo, offset);
            } else {
              // Fallback to the old
              var lastChild = this.models.stack.lastChild();
              var application = lastChild && lastChild.get("application");
              if (lastChild && application) {
                var iframes = $(application.rootEls).find("iframe");
                if (iframes.length) {
                  calcOffsetPosition(iframes[0], options.targetInfo, offset);
                }
              }
            }
          } else {
            if (options.event && options.event.currentTarget) {
              const el = options.event.currentTarget;
              const boundingClientRect = el.getBoundingClientRect();
              offset.top = boundingClientRect.top + window.scrollY;
              offset.left = boundingClientRect.left + window.scrollX;
              offset.bottom = boundingClientRect.bottom + window.scrollY;
              offset.right = boundingClientRect.right + window.scrollX;
            }
          }

          options.applicationOptions = {
            offset: offset
          };
        }

        const itemClassName = options.itemClassName;
        var m360Model = this.getMindbreeze360Model();
        if (!m360Model) {
          alert("no-360-view-configured-for-itemClassName");
          return;
        }

        // options.itemClassConfig is set in *:annotation:mouseover
        var itemClassConfig = options.itemClassConfig || m360Model.findItemClassConfigForResult(options.model.output);
        if (!itemClassConfig) {
          console.warn("no-360-view-configured-for-itemClassName");
          return;
        }

        var viewConfigForClass = m360Model.getViewConfigForClassName(itemClassName);

        const keyProperty = options.keyProperty || "mes:key";
        const key = options.key || (options.model && options.model.get("mes:key", { format: "VALUE" }));

        const modeFunction =
          options.mode === "preview" ? "showPreview" : "pushStack";

        var segmentsSettings = this._provideSegmentsSettingsForItemType(itemClassName);
        var constraint = options.constraint || that._get360ViewConstraint(options, itemClassConfig);
        var properties = options.properties || {};
        var applicationOptions = _.extend(options.applicationOptions || {}, {
          actionModel: options.model,
          itemClassName: itemClassName,
          // TODO
          constraint: constraint,
          itemClassConfig: itemClassConfig,
          viewConfigsFor360: viewConfigForClass,
          templateList: that.application.options.templateList,
          // TODO merge settings.
          settings: { segments: segmentsSettings },
          exprEnvironment: {
            // use current structure – assert that reserved names must not be used.
            itemClassName: itemClassName,
            itemClassConfig: itemClassConfig.config,
            segments: segmentsSettings,
            mainItem: {
              constraint: constraint,
              properties: properties
            }
          }
        });

        // explicitly remove view constraint settings
        if (
          this.application.options.initAction &&
          this.application.options.initAction.settings &&
          this.application.options.initAction.settings["view.constraint"]
        ) {
          applicationOptions.initAction = _.extend({}, this.application.options.initAction);
          delete applicationOptions.initAction.settings["view.constraint"];
        }

        // creates new application
        //    1. implicit: showPreview
        //    2. explicit: pushStack
        if (this.application[modeFunction]) {
          var appFragmentNameList = [itemClassName];
          appFragmentNameList = appFragmentNameList.concat(m360Model.getPrimaryAliasNamesForItemClassName(itemClassName));
          appFragmentNameList.push("generic");
          appFragmentNameList.push("default");
          
          var appFragmentNames = appFragmentNameList.join(" ");

          this.application[modeFunction]({
            mode: options.mode,
            event: options.event,
            content:
              '<div style=""><div data-app-fragment-ref-type="360" data-app-fragment-ref-names="' +
              appFragmentNames +
              '"></div></div>',
            action: "360view",
            startSearch: false,
            searchParams: {
              action: "show360",
              itemClassName: itemClassName,
              keyProperty: keyProperty === "mes:key" ? null : keyProperty,
              key: key
            },
            applicationOptions: applicationOptions,
            annotationId: options.annotationId
          });
        }
      },

      showPreview: function(options, traceContext) {
        var that = this;
        if (
          this.application.activePreview &&
          this.application.activePreview.annotationId == options.annotationId &&
          options.event &&
          this.application.activePreview.eventEl === (options.event && options.event.currentTarget)
        ) {
          return;
        }

        let previewEl;

        this._closePreview();
        previewEl = document.createElement("div");
        previewEl.className = "mb-stack-preview"; //-scaled'
        $(previewEl).css({
          top: options.applicationOptions.offset.bottom + "px",
          left: options.applicationOptions.offset.left + "px"
        });
        this.application.appendChildToRoot(previewEl)
        previewEl.addEventListener(
          "click",
          function(e) {
            e.preventDefault();
            that._closePreview();
            that.application.pushStack(options);
          },
          true
        );

        options.applicationOptions = _.extend(
          {
            queryURLParameter: "unused"
          },
          options.applicationOptions || {},
          {
            enableAccessibilityHandlers: false,
            parentApplication: that.application,
            callback: function(application) {
              if (application.options.feedbackHTML5ScreenshotDisabled) {
                application.feedbackHTML5ScreenshotWasEnabled = Trace.feedbackHTML5ScreenshotEnabled();
                Trace.enableHTML5Screenshot(false);
              }
              try {
                if (options.action && application[options.action]) {
                  application[options.action](options, traceContext);
                }
              } finally {
                traceContext && traceContext.leave();
              }
            }
          }
        );

        previewEl.innerHTML += options.content;

        const application = new (this.application.options.applicationConstructor || this.application.constructor)(
          _.extend(
            {
              rootEl: previewEl,
              startSearch: false
            },
            options.applicationOptions
          )
        );

        let previewState = {};
        const insideHandler = function() {
          if (that.application.activePreview && that.application.activePreview.previewState) {
            that.application.activePreview.previewState.ignoreAnnotationMouseOver = true;
            clearTimeout(that.delayClosePreviewTimeout);          }
        };

        const outsideHandler = function(handlerOptions) {
          if (
            handlerOptions.annotationId !== undefined &&
            that.application.activePreview &&
            that.application.activePreview.previewState &&
            that.application.activePreview.previewState.ignoreAnnotationMouseOver
          ) {
            that.application.activePreview.previewState.ignoreAnnotationMouseOver = false;
            return;
          }
          if (
            handlerOptions.annotationId &&
            handlerOptions.annotationId == that.application.activePreview.annotationId
          ) {
            that._closePreview(true);
          } else {
            that.delayClosePreviewTimeout = setTimeout(function() {
              that._closePreview();
            }, 500);
          }
        };
        
        if (options.event && options.event.currentTarget && options.event.currentTarget.addEventListener) {
          var isShow360Action = options.event.currentTarget.getAttribute('data-action-name') === 'show360';
          // Handle mouse mouseout only for 360 action, the annotation mouse out is handled by preview:annotation:mouseleave
          if (isShow360Action) {
            options.event.currentTarget.addEventListener("mouseover", insideHandler);
            options.event.currentTarget.addEventListener("mouseout", outsideHandler);
          }
        }

        previewEl.addEventListener("mouseover", insideHandler);
        previewEl.addEventListener("mouseout", outsideHandler);

        this.application.activePreview = {
          previewEl: previewEl,
          eventEl: options.event && options.event.currentTarget,
          application: application,
          previewState: previewState,
          insideHandler: insideHandler,
          outsideHandler: outsideHandler,
          frameEl: options.frameEl,
          annotationId: options.annotationId
        };
      },

      // application.360view() triggered from parent application
      // e.x *:annotation:mouseover or showPreview in parent has been triggered
      view360: function(options) {
        // action triggered after stack is available and
        // model intialized, no search done yet
        this.application.titleModel = options.titleModel;
        this.application.options.title = this.application.options.title || options.title;
        this.collection = Object.values(this.application.models.search.resultProperties).find(function(
          resultProperties
        ) {
          return resultProperties.constructor === Search.ResultCollection && !resultProperties.objectTypeCollection;
        });
        var model = this.application.models.search;
        this._prepare360ViewMainModel(model);
        model.set("name", this.application.options.itemClassName + "-360", {
          silent: true
        });
        model.set("count", 1, { silent: true });
        // triggeres the initial search that then triggers the udpate360TitleAndLoadRelationsships
        model.set("constraint", this.application.options.constraint);
        var that = this;

        // avoid in desginer
        if (!that.application.editing) {
          model.on("computed", function() {
            if (that.application.rootEls && that.application.parentApplication.activePreview) {
              const rect = that.application.rootEls.getBoundingClientRect();
              const viewportWidth = window.innerWidth;
              const viewportHeight = window.innerHeight;
  
              // Get the scroll position
              const scrollTop = window.scrollY;
              const scrollLeft = window.scrollX;
  
              // Adjust the position if the element overflows the viewport
              if (rect.right > viewportWidth) {
                that.application.rootEls.style.left = scrollLeft + viewportWidth - 50 - rect.width + "px";
              }
              if (rect.bottom > viewportHeight) {
                that.application.rootEls.style.top = scrollTop + viewportHeight - 30 - rect.height + "px";
              }
              if (rect.left < 0) {
                that.application.rootEls.style.left = scrollLeft + "px";
              }
              if (rect.top < 0) {
                that.application.rootEls.style.top = scrollTop + "px";
              }
            }
          });
        }

      },

      showAllResults: function(options) {
        const constraints = {
          constraint: options.model.input.get("constraint"),
          user: options.model.input.get("user"),
          source_context: options.model.input.get("source_context"),
          count: 5
        };

        var channels = null;
        if (
          options.model.wiring &&
          options.model.wiring.channel != this.channels &&
          options.model.wiring.channel &&
          options.model.wiring.channel instanceof Channel
        ) {
          channels = [options.model.wiring.channel];
        }

        if (options.count) {
          try {
            constraints.count = parseInt(options.count);
          } catch (e) {
            console.log("Failed to parse count from action", options.count, e);
          }
        }

        var content = null;
        if (options.targetAppFragmentType) {
          var targetAppFragmentNames = options.targetAppFragmentNames || "default";

          content =
            '<div style=""><div data-app-fragment-ref-type="' +
            options.targetAppFragmentType +
            '" data-app-fragment-ref-names="' +
            targetAppFragmentNames +
            '"></div></div>';
        } else {
          content = SHOW_MORE_RESULT_TEMPLATE && SHOW_MORE_RESULT_TEMPLATE.default;
        }

        var applicationOptions = {};
        if (channels) {
          // we have different channels than the outer constraint
          // sources take precedence of channels
          applicationOptions.sources = channels;
          applicationOptions.ignoreChannelsConstraint = true;
        }
        this.application.pushStack({
          title: options.title,
          content: content,
          action: "setOnSearchModel",
          input: constraints,
          applicationOptions: applicationOptions
        });
      },

      setOnSearchModel: function(options) {
        this.application.models.search.set(options.input);
      },

      transform360InputForResult: function(destItemClassName, segmentInput) {
        this._resetInput(segmentInput);

        let resultProperties = this.application.models.search.get("resultset.results[0].properties");

        if (!resultProperties) {
          throw Error("no result available for tranforming input for " + destItemClassName);
        }

        let resultModel = new PropertiesModel(resultProperties);

        var currentItemClassConfig = this.application.options.itemClassConfig || this.config.itemClassConfig;
        var m360Model = this.getMindbreeze360Model();
        var destItemClassConfig = m360Model.findItemClassConfigForName(destItemClassName);
        if (!destItemClassConfig) {
          console.log("360: destination item class not found in conig: " + destItemClassName);
          return;
        }

        if (!currentItemClassConfig) {
          console.warn("currentItemClassConfig is undefined!");
          return;
        }

        const relationship = currentItemClassConfig.name + "_to_" + destItemClassConfig.name;

        segmentInput.name = relationship;

        var getResultPropertyValuesFun = function(propertyName) {
          return ArrayUtils.ensureArray(resultModel.get(propertyName, { format: "VALUE" }));
        };

        var linkConstraints = m360Model.getLinkConstraints(
          currentItemClassConfig,
          destItemClassConfig,
          getResultPropertyValuesFun
        );

        segmentInput.constraint = {
          and: [destItemClassConfig.definitionMatchCriteria.toQueryConstraint()]
        };

        if (!_.isEmpty(linkConstraints)) {
          segmentInput.constraint.and = segmentInput.constraint.and.concat([
            {
              or: _.map(linkConstraints, function(linkConstraint) {
                return linkConstraint.toQueryExpr();
              })
            }
          ]);
        } else {
          segmentInput.constraint.and.push({
            label: "category",
            quoted_term: "must not find any results because of relationship"
          });

          console.warn({
            message:
              "360:" +
              currentItemClassConfig.name +
              " does not have values to build constraint for relationship" +
              destItemClassConfig.name,
            model: resultModel,
            sourceItemClassName: currentItemClassConfig.name,
            destItemClassName: destItemClassConfig.name,
            config: m360Model.getConfig()
          });
        }
      },

      getMindbreeze360Model: function() {
        if (this.mindbreeze360Model) {
          return this.mindbreeze360Model;
        }

        if (!this.config) {
          return null;
        }

        if (this.config == null) {
          return null;
        }
        this.mindbreeze360Model = new MindbreezeModels.Mindbreeze360Model(this.config);
        return this.mindbreeze360Model;
      },

      _closePreview: function() {
        if (!this.application.activePreview) return;
        clearTimeout(this.delayClosePreviewTimeout);
        
        this.application.activePreview.application.destroy();
        this.application.activePreview.previewEl.parentNode.removeChild(this.application.activePreview.previewEl);

        if (this.application.activePreview.eventEl && this.application.activePreview.eventEl.removeEventListener) {
          this.application.activePreview.eventEl.removeEventListener(
            "mouseover",
            this.application.activePreview.insideHandler
          );
          this.application.activePreview.eventEl.removeEventListener(
            "mouseout",
            this.application.activePreview.outsideHandler
          );
        }

        if (this.application.activePreview.previewEl && this.application.activePreview.previewEl.removeEventListener) {
          this.application.activePreview.previewEl.removeEventListener(
            "mouseover",
            this.application.activePreview.insideHandler
          );
          this.application.activePreview.previewEl.removeEventListener(
            "mouseout",
            this.application.activePreview.outsideHandler
          );
        }
        delete this.application.activePreview;
      },

      _getComputedProperties: function(linkSourcePropertyNames) {
        var computedProperties = [];
        _.each(_.keys(linkSourcePropertyNames), function(propName) {
          var annotationSuffix = "/annotation/mes:key";
          if (propName.endsWith(annotationSuffix)) {
            var immPropName = propName.substr(0, propName.length - annotationSuffix.length);
            computedProperties.push({
              name: propName,
              expr: "annotation(" + immPropName + ',"mes:key")'
            });
          }
        });
        return computedProperties;
      },
      
      _prepare360ViewMainModel: function(model) {
        model = model || this.application.models.search;

        var linkSourcePropertyNames = this._getRelationshipProperties();

        var computedProperties = [];
        _.each(_.keys(linkSourcePropertyNames), function(propName) {
          var annotationSuffix = "/annotation/mes:key";
          if (propName.endsWith(annotationSuffix)) {
            var immPropName = propName.substr(0, propName.length - annotationSuffix.length);
            computedProperties.push({
              name: propName,
              expr: "annotation(" + immPropName + ',"mes:key")'
            });
          }
        });

        if (!_.isEmpty(computedProperties)) {
          var existingComputedProperties = model.input.get("computed_properties") || [];
          var effectiveProps = existingComputedProperties.concat(computedProperties);
          model.input.set("computed_properties", effectiveProps, {
            silent: true
          });
        }

        this.collectionForConstraints = new Search.ResultCollection(linkSourcePropertyNames);
        // if we have have a result then add is triggered and this
        this.application.listenTo(
          this.collectionForConstraints,
          "add",
          this._update360TitleAndLoadRelationships.bind(this)
        );
        model.once("dispose", function() {
          return this.collectionForConstraints.dispose();
        });
        model.addResultCollection(this.collectionForConstraints, {
          silent: true
        });
      },

      _provideSegmentsSettingsForItemType: function(itemClassName) {
        var m360Model = this.getMindbreeze360Model();
        var viewConfigForClass = m360Model.getViewConfigForClassName(itemClassName);
        // TODO: 1 not use config but use object model
        //       2 allow object as view config not only array of segments.

        if (!_.isArray(viewConfigForClass)) {
          console.warn("Failed to interpret view config for class ", itemClassName);
          return { };
        }

        var segmentSettings = _.reduce(
          viewConfigForClass,
          function(result, viewConfigElement) {
            var itemClassName;

            if (_.isString(viewConfigElement)) {
              // class reference
              itemClassName = viewConfigElement;
            } else if (_.isObject(viewConfigElement)) {
              if (viewConfigElement.title) {
                itemClassName = viewConfigElement.title;
              } else {
                itemClassName = viewConfigElement.itemClass;
              }
            }

            result[itemClassName] = {
              searchSettingsPath: "settings." + itemClassName + ".search",
              // these are settings that can be used to control the
              //  search template.
              search: {
                templateTitle: itemClassName,
                model: "segment" + itemClassName.charAt(0).toUpperCase() + itemClassName.slice(1),
                count: 2,
                computeOnchange: "output",
                inputTransform: "application.transform360Input('" + itemClassName + "', input)"
              }
            };

            // TODO rename it with searchSettings?
            if (_.isObject(viewConfigElement) && viewConfigElement.searchInput) {
              result[itemClassName].search = _.extend(result[itemClassName].search, viewConfigElement.searchInput);
            }

            return result;
          },
          {}
        );

        return segmentSettings;
      },

      _getPropertyValue: function(result, propertyName) {
        if (!result) {
          return null;
        }

        return new PropertiesModel(result.properties).get(propertyName, {
          format: "VALUE"
        });
      },

      _getRelationshipProperties: function() {
        var destClassNames = _.keys(
          (this.config.settings && this.config.settings.segments) ||
            (this.application.options.settings && this.application.options.settings.segments)
        );

        var itemClassConfig = this.application.options.itemClassConfig || this.config.itemClassConfig;

        if (!itemClassConfig) {
          console.warn("Target itemClassConfig is missing, skipped.");
          return;
        }

        var sourcePropertyNames = this.getMindbreeze360Model().getLinkSourceProperties(itemClassConfig, destClassNames);

        return _.reduce(
          sourcePropertyNames,
          function(result, propertyName) {
            result[propertyName] = { format: "VALUE" };
            return result;
          },
          {}
        );
      },

      _getRegexConstraint: function(model, propertyName) {
        propertyName = propertyName || "mes:key";
        const propertyValue = model.get(propertyName, { format: "VALUE" });
        return { label: propertyName, regex: "^\\Q" + propertyValue + "\\E$" };
      },
      
      _get360ViewConstraint: function(actionOptions, itemClassConfig) {
        // TODO: What about zip files?
        const keyProperty = actionOptions.keyProperty || "mes:key";
        const key = actionOptions.key || actionOptions.model.get("mes:key", { format: "VALUE" });
        const keyConstraint = {
          label: keyProperty
        };

        keyConstraint.regex = "^\\Q" + key + "\\E$";

        const itemClassConstraint = itemClassConfig.definitionMatchCriteria.toQueryConstraint();
        if (!itemClassConstraint) {
          return keyConstraint;
        }
        return {
          and: [keyConstraint, itemClassConstraint]
        };
      },

      _update360TitleAndLoadRelationships: function() {
        let resultProperties = this.application.models.search.get("resultset.results[0].properties");

        // this is like an action on the model of the main result
        let model = new PropertiesModel(resultProperties);

        if (this.application.titleModel) {
          this.application.titleModel.set(
            "title",
            "<h2>" + i18n("client_360_degree_view_of", [model.get("title", { format: "VALUE" })]) + "</h2>"
          );
        }
      },

      _checkIsMainEntryForViewAndProvideVars: function(results) {
        if (!results) {
          return;
        }
        var resultList = results.get();

        if (resultList == null || resultList.length != 1 || !this.application.exprEnvironment  ||
            !(this.application.exprEnvironment.referencesVariable("segments")
              || this.application.exprEnvironment.referencesVariable("itemClassConfig")
              || this.application.exprEnvironment.referencesVariable("itemClassName"))) {
          return;
        }
        const m360Model = this.getMindbreeze360Model();
        var resultPropertiesModel = new PropertiesModel(resultList[0].properties);
        const itemClassConfig = m360Model.findItemClassConfigForResult(resultPropertiesModel);

        // main entry has been checked and the 360 view has got its itemClassConfig
        if (!itemClassConfig || this.application.options.itemClassConfig || this.config.itemClassConfig) {
          return;
        }

        this.config.itemClassConfig = itemClassConfig;
        this.config.itemClassName = itemClassConfig.name;
        var model = this.application.models.search;
        var segmentsSettings = this._provideSegmentsSettingsForItemType(itemClassConfig.name);
        this.config.settings = _.extend({ segments: segmentsSettings }, this.application.options.settings || {});
        if (!this.application.options.settings) {
          this.application.options.settings = this.config.settings;
        }

        var mainItemConstraint = itemClassConfig.definitionMatchCriteria.toQueryConstraint();

        var variablesSet = false;
        const setItemClassVariables = () => {
          if (variablesSet) {
            return;
          }
          this.application.exprEnvironment.setVariables({
            segments: segmentsSettings,
            itemClassName: this.config.itemClassName,
            itemClassConfig: this.config.itemClassConfig.config,
            mainItem: {
              constraint: {
                and: [this._getRegexConstraint(resultPropertiesModel, "mes:key"), mainItemConstraint]
              }
            }
          });
          variablesSet = true;
        };
        model.output.once("change", setItemClassVariables);
        this._prepare360ViewMainModel(model);
        model.input.change();
        // check if the change did not happen, because
        //  nothing was changed, then change is not triggered
        if (_.isEmpty(model.input.changed)) {
          // directly set item class variables
          setItemClassVariables();
        }
      },

      _resetInput: function(input) {
        var key;
        for (key in input) {
          if (input.hasOwnProperty(key)) {
            delete input[key];
          }
        }
      }
    });

    return Degree360;
  }
);
